import { render, staticRenderFns } from "./FeedsCreate.vue?vue&type=template&id=23cea10a&"
import script from "./FeedsCreate.vue?vue&type=script&lang=js&"
export * from "./FeedsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports